export var SortOrder;
(function (SortOrder) {
    SortOrder["SORT_ORDER_UNSPECIFIED"] = "SORT_ORDER_UNSPECIFIED";
    SortOrder["SORT_ORDER_ASC"] = "ASC";
    SortOrder["SORT_ORDER_DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
